import { TrueSightEffect } from 'game/extended/heros/ranger/true_sight/true_sight_effect'

export default {
    events: {},
    effects: {
        TrueSightEffect
    },
    requirements: {}
}